import { IUpdateEspecificidadeObraUseCase } from "../../../presentation/useCases/update/update_especificidade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateEspecificidadeObraUseCase
 */

export class UpdateEspecificidadeObraUseCase implements IUpdateEspecificidadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateEspecificidadeObra(
    idEspecificidadeObra: number,
    item: string,
    formaControle: string,
  ): Promise<void> {
    await this.repository.updateEspecificidadeObra(
      idEspecificidadeObra,
      item,
      formaControle,
    );
  }
}
